module.exports = __webpack_public_path__ + "media/images/players/MUÑOZ_SEBASTIAN-40d877243ba0dbe876e6710833dca94a.png";